import { Analysis } from 'common-spectrum';
import { hgParseThermoFinnigan } from 'physical-chemistry-parser';

export function fromThermoFinnigan(blob) {
  let analysis = new Analysis();

  const parsed = hgParseThermoFinnigan(blob);

  let meta = {
    ...parsed.meta.solidReporting,
    ...parsed.meta.testInformation,
    ...parsed.meta.analyticalConditions,
    ...parsed.meta.preparation,
    ...parsed.meta.totalPoreSize,
  };

  meta.cheminfo = { meta: getNormalizedMeta(meta) };

  let y = {
    data: parsed.variables.B.data,
    label: parsed.variables.B.label,
    units: parsed.variables.B.units,
    type: 'DEPENDENT',
  };
  if (y.units === 'mm³/g') {
    y.units = 'mL/g';
    y.data = y.data.map((datum) => datum / 1000);
  }
  analysis.pushSpectrum(
    {
      x: {
        data: parsed.variables.E.data,
        label: parsed.variables.E.label,
        units: parsed.variables.E.units,
        type: 'INDEPENDENT',
      },
      y,
    },
    {
      dataType: 'Hg porosimetry',
      title: parsed.meta.testInformation['Sample name'],
      meta: meta,
      tmp: parsed,
    },
  );

  return analysis;
}

function getNormalizedMeta(meta) {
  const result = {};
  result.date = meta['Test date'];
  result.skeletonDensity = metaWithUnits(meta, 'Sample skeleton density');
  result.mercuryContactAngle = metaWithUnits(meta, 'Mercury contact angle');
  result.totalPoreVolume = metaWithUnits(meta, 'Total pore volume');
  result.totalPoreArea = metaWithUnits(meta, 'Total pore surface area');
  result.averagePoreDiameter = metaWithUnits(meta, 'Average pore diameter');
  return result;
}

function metaWithUnits(meta, metaName) {
  const key = Object.keys(meta).filter((key) => key.startsWith(metaName))[0];
  if (key) {
    let value = meta[key];
    if (typeof value === 'string') value = Number(value.replace(/;.*/, ''));
    const units = key
      .replace(/^.*\((?<units>.*)\).*/, '$1')
      .replace(/([23])/, '^$1');
    return {
      value,
      units,
    };
  }
  return undefined;
}
